import React from 'react';
import { useTranslation } from 'react-i18next';
import type { KeywordGroup } from '@brand24-original/llm-types';
import BrandIcon from '../../../../shared/components/brand-icon/BrandIcon';
import BrandBadges from '../../../../shared/components/brand-badges/BrandBadges';
import './BrandLabelCell.scss';

interface BrandLabelCellProps {
  group: KeywordGroup;
  /** Kolor marki z palety raportu — tło literki, gdy nie ma favicona. */
  color: string;
  /** Domena marki — favicon zamiast literki. */
  domain?: string;
  isMain: boolean;
  isSelected: boolean;
  /** Otwiera okno marki — nazwę zmienia się w zakładce „Podstawowe”. */
  onOpen: () => void;
}

/**
 * Nazwa marki w wierszu. Etykieta jest wyłącznie do wyświetlania — grupowanie i statystyki trzymają
 * się kanonika; bez etykiety wraca nazwa wiersza reprezentanta.
 */
export const BrandLabelCell: React.FC<BrandLabelCellProps> = ({
  group,
  color,
  domain,
  isMain,
  isSelected,
  onOpen,
}) => {
  const { t } = useTranslation();
  const name = group.label ?? group.keyword;

  return (
    <span className="keyword-cell keyword-cell--brand">
      <BrandIcon name={name} domain={domain} color={color} size="md" />
      <button type="button" className="brand-label" title={t('brandLabelEdit')} onClick={onOpen}>
        <span className="brand-label__name">{name}</span>
      </button>
      <BrandBadges isMain={isMain} isSelected={isSelected} />
    </span>
  );
};

export default BrandLabelCell;
